module.exports = __webpack_public_path__ + "img/door.4435e169.svg";